import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type CanvasDeleteModalAction = "confirm" | "cancel";

export function useEmitCanvasDeleteModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: CanvasDeleteModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.CanvasDeleteModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
